import { GridItem, Heading } from "@chakra-ui/react";
import * as React from "react";

function HeadingGridItem({ colSpan, text }) {
  return (
    <GridItem colSpan={colSpan ?? 1} border="1px solid lightgray" padding="10px 5px" alignItems="center">
      <Heading marginBlock="1" size="sm">
        {text}
      </Heading>
    </GridItem>
  )
}

export default HeadingGridItem;